<div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center" *ngIf="(isUserLoggedIn$ | async) === false">
  <div class="main-col withBottomPadding" [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">
    <image-slider [fxHide]="!hasSliderImages" [page]="'publicCompanyProfile'" no-image-margin="60px"></image-slider>

    <app-business-new-profile
      (createNewProfile)="newCarpenterProfile()"
      (createNewProfileCarpenterPlus)="newCarpenterPlusProfile()"
      (createNewProfileOther)="newOtherProfile()"
    >
    </app-business-new-profile>
  </div>
</div>

<app-footer></app-footer>
